import { convert } from '@revenuemarket/utils';
import { useRouter } from 'next/router';

export function useQueryParam(key: string): string | undefined;
export function useQueryParam<T>(
  key: string,
  options?: { parser?: (value: string) => T },
): T | undefined;
export function useQueryParam<T>(
  key: string,
  options?: { parser?: (value: string) => T },
): T | undefined {
  const router = useRouter();
  const value = convert(router.query[key] as string | undefined, decodeURIComponent);
  if (options?.parser != null && value != null) {
    return options.parser(value);
  }
  return value as T | undefined;
}
